import { useContext } from 'react';
import { usePromise } from 'oasis-os-utils';
import { ClientContext } from './ContentfulProvider';
/**
 * Access the client instance from React context.
 * @see https://contentful.github.io/contentful.js/contentful/8.2.0/ContentfulClientAPI.html
 */
export const useClient = () => useContext(ClientContext);
/**
 * Retrieve an Entry from contentful CDN. Returns a [result, error] tuple.
 * When id is false-ish, nothing happens, so you may still use this hook outside a conditional.
 * @see https://contentful.github.io/contentful.js/contentful/8.2.0/ContentfulClientAPI.html#.getEntry
 */
export const useEntry = (id, query, dependencies) => {
    const client = useClient();
    return usePromise(() => id
        ? client.context.getEntry(id, query)
        : Promise.resolve(undefined), dependencies || [id]);
};
/**
 * Retrieve a collection of Entries from contentful CDN.
 * When query is false-ish, nothing happens, so you may still use this hook outside a conditional.
 * @see https://contentful.github.io/contentful.js/contentful/8.2.0/ContentfulClientAPI.html#.getEntries
 */
export const useEntries = (query, dependencies) => {
    const client = useClient();
    return usePromise(() => query
        ? client.context.getEntries(query)
        : Promise.resolve(undefined), dependencies || []);
};
/**
 * Retrieve an Asset from contentful CDN. Returns a [result, error] tuple.
 * When id is false-ish, nothing happens, so you may still use this hook outside a conditional.
 * @see https://contentful.github.io/contentful.js/contentful/8.2.0/ContentfulClientAPI.html#.getAsset
 */
export const useAsset = (id, query, dependencies) => {
    const client = useClient();
    return usePromise(() => id ? client.context.getAsset(id, query) : Promise.resolve(undefined), dependencies || [id]);
};
/**
 * Retrieve a collection of Assets from contentful CDN.
 * When query is false-ish, nothing happens, so you may still use this hook outside a conditional.
 * @see https://contentful.github.io/contentful.js/contentful/8.2.0/ContentfulClientAPI.html#.getAssets
 */
export const useAssets = (query, dependencies) => {
    const client = useClient();
    return usePromise(() => query ? client.context.getAssets(query) : Promise.resolve(undefined), dependencies || []);
};
